import {
  AccountType,
  isExhibitionArtificialEmail,
  type AccountType as AccountTypeValue,
} from '@paladin-monorepo/common';
import type { UserProps } from '@/lib/auth';

export function isExhibitionKioskUser(user: UserProps | null | undefined): boolean {
  return isExhibitionArtificialEmail(user?.email);
}

export function isExhibitionKioskAllowedPath(path: string): boolean {
  if (path === '/exhibition/start') return true;
  if (path.startsWith('/llm-chat/') && path.length > '/llm-chat/'.length) return true;
  return false;
}

function exhibitionTypeConfirmedKey(accountId: string): string {
  return `exhibition-type-confirmed:${accountId}`;
}

export function isExhibitionTypeConfirmed(accountId: string): boolean {
  try {
    return sessionStorage.getItem(exhibitionTypeConfirmedKey(accountId)) === '1';
  } catch {
    return false;
  }
}

export function markExhibitionTypeConfirmed(accountId: string): void {
  try {
    sessionStorage.setItem(exhibitionTypeConfirmedKey(accountId), '1');
  } catch {
    // ignore quota / private mode
  }
}

export function clearExhibitionTypeConfirmed(accountId: string): void {
  try {
    sessionStorage.removeItem(exhibitionTypeConfirmedKey(accountId));
  } catch {
    // ignore quota / private mode
  }
}

/** True when the exhibition role dialog must be shown and industry start must wait. */
export function needsExhibitionTypeDialog(
  user: UserProps | null | undefined,
  exhibitionArrival: boolean,
): boolean {
  if (!isExhibitionKioskUser(user) || !user?.account) {
    return false;
  }
  if (
    isExhibitionTypeConfirmed(user.account.id) &&
    user.account.accountType === AccountType.Inquirer
  ) {
    return false;
  }
  if (
    isExhibitionTypeConfirmed(user.account.id) &&
    user.account.accountType !== AccountType.Inquirer
  ) {
    clearExhibitionTypeConfirmed(user.account.id);
  }
  return exhibitionArrival || user.account.accountType !== AccountType.Inquirer;
}

export function exhibitionTypeDialogDefault(): AccountTypeValue {
  return AccountType.Inquirer;
}
